import * as jQuery from 'jquery';

export const $ = jQuery;
export const gridBreakpoints = {
    xs: 0,
    sm: 600,
    md: 768,
    lg: 1024,
    xl: 1279,
    xxl: 1440
};

const googleSheetListExport = [
    {
        guests: 0,
        name: 'Wedding Party',
        emails: ''
    },
    {
        guests: 2,
        name: 'Cori & Rocko Bolts',
        emails: 'clpinkett@gmail.com'
    },
    {
        guests: 1,
        name: 'River Washington',
        emails: 'riverwashington@gmail.com'
    },
    {
        guests: 1,
        name: 'Tiara Wright',
        emails: 'tiarawright16@gmail.com'
    },
    {
        guests: 1,
        name: 'Keiko Cooley',
        emails: 'keikocooley@gmail.com'
    },
    {
        guests: 1,
        name: 'Tiara Myrick',
        emails: 'tmyrick16@gmail.com'
    },
    {
        guests: 1,
        name: 'Jalisa Washington',
        emails: 'jalwashington2@gmail.com'
    },
    {
        guests: 2,
        name: 'Shardae Moore & Milton Davis',
        emails: 'shardaemoore22@yahoo.com'
    },
    {
        guests: 2,
        name: 'Avery & Baylee Johnson',
        emails: 'baylee_hawkins@yahoo.com'
    },
    {
        guests: 2,
        name: 'Jordan Pinkett & Emi Douglas',
        emails: 'jpinkett619@gmail.com'
    },
    {
        guests: 2,
        name: 'James & Tori Cunningham',
        emails: 'jamcunningham2@gmail.com'
    },
    {
        guests: 2,
        name: 'Zae & Liana Holland',
        emails: 'zaphane.holland@gmail.com'
    },
    {
        guests: 1,
        name: 'Arthur Brown',
        emails: 'abrownchas1@gmail.com'
    },
    {
        guests: 1,
        name: 'Trey Swinton',
        emails: 'treyswinton@gmail.com'
    },
    {
        guests: 2,
        name: 'John & Caitlin Swinton',
        emails: 'johncfswinton@gmail.com'
    },
    {
        guests: 0,
        name: '',
        emails: ''
    },
    {
        guests: 0,
        name: 'Chelsi Immediate Family',
        emails: ''
    },
    {
        guests: 2,
        name: 'Monte & Sharon Pinkett',
        emails: 'SRCPinkett@gmail.com'
    },
    {
        guests: 2,
        name: 'Dee Cannedy & Robert Lowery',
        emails: 'cannedy42@gmail.com'
    },
    {
        guests: 1,
        name: 'Pamela Pinkett',
        emails: 'pspinkett@aol.com'
    },
    {
        guests: 0,
        name: '',
        emails: ''
    },
    {
        guests: 0,
        name: 'Spencer Immediate Family',
        emails: ''
    },
    {
        guests: 2,
        name: 'Philip & Louise Johnson',
        emails: 'lkjohnson25@yahoo.com'
    },
    {
        guests: 1,
        name: 'Granny (Spence)',
        emails: ''
    },
    {
        guests: 0,
        name: '',
        emails: ''
    },
    {
        guests: 0,
        name: 'Aunts & Uncles (Chelsi)',
        emails: ''
    },
    {
        guests: 2,
        name: 'Tamara Pinkett & Will Beasley',
        emails: 'tpstat89@gmail.com'
    },
    {
        guests: 2,
        name: 'Shawn & Ann Pinkett',
        emails: 'cadada@bellsouth.net'
    },
    {
        guests: 1,
        name: 'John Cannedy',
        emails: 'Jecannedy3@gmail.com'
    },
    {
        guests: 1,
        name: 'Benjamin Cannedy',
        emails: 'bkingtodd2@gmail.com'
    },
    {
        guests: 0,
        name: '',
        emails: ''
    },
    {
        guests: 0,
        name: 'Aunt & Uncles (Spence)',
        emails: ''
    },
    {
        guests: 1,
        name: 'Lavesta Johnson',
        emails: ''
    },
    {
        guests: 2,
        name: 'Domino & Jackie Boulware',
        emails: 'boulwa_j@bellsouth.net'
    },
    {
        guests: 1,
        name: 'Deloris Johnson',
        emails: 'deloreshurt@yahoo.com'
    },
    {
        guests: 1,
        name: 'Vera Burkett',
        emails: 'Veramburkett1948@gmail.com'
    },
    {
        guests: 1,
        name: 'Aunt Jackie Stimage-Norwood',
        emails: 'Jsn4032@gmail.com'
    },
    {
        guests: 1,
        name: 'Mary Ayers',
        emails: 'maryayers@bellsouth.net'
    },
    {
        guests: 2,
        name: 'Michael & Lynda Whiteside',
        emails: 'mslynda50@hotmail.com'
    },
    {
        guests: 2,
        name: 'William & Cheryl Swinton',
        emails: 'cherylswinton27@gmail.com; williamswinton@aol.com'
    },
    {
        guests: 1,
        name: 'Caroline Swinton',
        emails: 'carolynswinton@hotmail.com'
    },
    {
        guests: 2,
        name: 'Collin & Adrian Hayes',
        emails: 'tsulaw95@gmail.com'
    },
    {
        guests: 2,
        name: 'Harold & Diane Swinton',
        emails: 'haroldlswinton@gmail.com'
    },
    {
        guests: 0,
        name: '',
        emails: ''
    },
    {
        guests: 0,
        name: 'Extended Family (Pinkett)',
        emails: ''
    },
    {
        guests: 1,
        name: 'Angela Bishop',
        emails: 'Adbishop67@gmail.com'
    },
    {
        guests: 1,
        name: 'Ruby Bishop',
        emails: 'rbee1952@yahoo.com'
    },
    {
        guests: 2,
        name: 'Howard & Joy Hamilton',
        emails: 'HowardHamiltonJR@gmail.com'
    },
    {
        guests: 2,
        name: 'Shayla Aytch (Marcie) & Husband',
        emails: 'angels2love7@yahoo.com'
    },
    {
        guests: 1,
        name: 'Rayonna Dixon',
        emails: 'rayonnadixon04@gmail.com'
    },
    {
        guests: 2,
        name: 'Mark Aytch & Betty McAllister',
        emails: 'markasr1971@gmail.com'
    },
    {
        guests: 1,
        name: 'Melodie Gale',
        emails: 'mgale0303@gmail.com'
    },
    {
        guests: 1,
        name: 'Carolyn Opher',
        emails: 'copher1@verizon.net'
    },
    {
        guests: 1,
        name: 'Aunt JoAnne Kirkwood',
        emails: ''
    },
    {
        guests: 1,
        name: 'Aunt Donzell Aytch',
        emails: ''
    },
    {
        guests: 2,
        name: 'Aunt Bobbie (Adam & Barbara Haynes)',
        emails: '01reginagale@comcast net'
    },
    {
        guests: 2,
        name: 'Quincy & Billie Verne Harrison',
        emails: 'blvharrison@aol.com'
    },
    {
        guests: 1,
        name: 'Romandie Green',
        emails: 'romandiegreen5717@comcast.net'
    },
    {
        guests: 1,
        name: 'Meredith Green',
        emails: 'meg70128@hotmail.com'
    },
    {
        guests: 2,
        name: 'Teddy & Doris Jeter',
        emails: 'dorisjeter4548@comcast.net; Theodorejeter88@gmail.com'
    },
    {
        guests: 1,
        name: 'Tia Selby',
        emails: 'Tiaselby@hotmail.com'
    },
    {
        guests: 1,
        name: 'Uncle Chuck',
        emails: ''
    },
    {
        guests: 1,
        name: 'Hewitt Doane',
        emails: 'Htdoane@yahoo.com'
    },
    {
        guests: 0,
        name: '',
        emails: ''
    },
    {
        guests: 0,
        name: 'Extended Family (Cannedy)',
        emails: ''
    },
    {
        guests: 1,
        name: 'Traci McKinney',
        emails: 'MSTRM3@yahoo.com'
    },
    {
        guests: 1,
        name: 'DeJean Cannedy',
        emails: 'therealdejean@gmail.com'
    },
    {
        guests: 1,
        name: 'LaQuiesha Cannedy',
        emails: ''
    },
    {
        guests: 1,
        name: 'Benjamin Todd Cannedy',
        emails: 'Bkingtodd2@gmail.com'
    },
    {
        guests: 2,
        name: 'Demetrius & Melanie McKinney',
        emails: 'Dmckinney2409@gmail.com '
    },
    {
        guests: 1,
        name: 'Dante McKinney',
        emails: 'yungmcpc1212@gmail.com'
    },
    {
        guests: 2,
        name: 'Richard & Janice Calloway',
        emails: 'janicesc39@yahoo.com'
    },
    {
        guests: 2,
        name: 'Kevin & Kelley Young',
        emails: 'drkelleyyoung@gmail.com'
    },
    {
        guests: 1,
        name: 'Elan Texiera',
        emails: 'ejaedinc@gmail.com'
    },
    {
        guests: 1,
        name: 'Anissa Collins',
        emails: 'flossnbrush2@yahoo.com'
    },
    {
        guests: 1,
        name: 'Jameliah Byrd-Daniels',
        emails: 'J.shanai91@gmail.com'
    },
    {
        guests: 0,
        name: '',
        emails: ''
    },
    {
        guests: 0,
        name: 'Extended Family (Johnson)',
        emails: ''
    },
    {
        guests: 1,
        name: 'Joron (Jojo) Stimage-Norwood',
        emails: 'jnorwood20@pm.me'
    },
    {
        guests: 1,
        name: 'Marcus Stimage-Norwood',
        emails: '1'
    },
    {
        guests: 1,
        name: 'Vashti Hurt',
        emails: 'vashti.hurt@yahoo.com'
    },
    {
        guests: 2,
        name: 'Yolanda & George Brown',
        emails: 'Yolandamburkett@icloud.com, Gpscolumbiasc@gmail.com'
    },
    {
        guests: 2,
        name: 'Nina-Serena & Mason Olonade',
        emails: 'Sirinafae05@yahoo.com'
    },
    {
        guests: 1,
        name: 'Nia Stimage Norwood',
        emails: 'niastimnor@gmail.com'
    },
    {
        guests: 1,
        name: 'Aaron Stimage-Norwood',
        emails: ''
    },
    {
        guests: 1,
        name: 'Erica Ladson',
        emails: 'erica_ladson@yahoo.com'
    },
    {
        guests: 1,
        name: 'Ashley Ladson',
        emails: 'Ashley_Ladson@yahoo.com'
    },
    {
        guests: 2,
        name: 'Fred & Angie Ladson',
        emails: 'Angelaladson@aol.com'
    },
    {
        guests: 2,
        name: 'Cousin Frankie & Lisa Summers',
        emails: ''
    },
    {
        guests: 2,
        name: 'Nathalie Owens & Annette Morrison',
        emails: ''
    },
    {
        guests: 1,
        name: 'Aunt Cathy Summers',
        emails: ''
    },
    {
        guests: 1,
        name: 'Lorren Summers',
        emails: ''
    },
    {
        guests: 1,
        name: 'Brittany Summers',
        emails: ''
    },
    {
        guests: 0,
        name: '',
        emails: ''
    },
    {
        guests: 0,
        name: 'Extended Family (Swinton)',
        emails: ''
    },
    {
        guests: 1,
        name: 'Athena Davis',
        emails: 'pandora197473@yahoo.com'
    },
    {
        guests: 1,
        name: 'Cousin Harold Swinton',
        emails: '1'
    },
    {
        guests: 1,
        name: 'Cousin Avery Swinton',
        emails: ''
    },
    {
        guests: 1,
        name: 'TamRhan Mack',
        emails: 'tamrhanyvette@gmail.com'
    },
    {
        guests: 1,
        name: 'Tamia Whiteside',
        emails: 'kool28kidz@gmail.com'
    },
    {
        guests: 1,
        name: 'Faith White',
        emails: ''
    },
    {
        guests: 1,
        name: 'Keosha Ayers',
        emails: 'silvergal2003@yahoo.com'
    },
    {
        guests: 1,
        name: 'Kyrah Ayers',
        emails: ''
    },
    {
        guests: 1,
        name: 'Keaunna Preheim',
        emails: 'preheimmom@gmail.com'
    },
    {
        guests: 1,
        name: 'Aliah Ayers',
        emails: ''
    },
    {
        guests: 1,
        name: 'Heather Swinton',
        emails: 'hlswinton@msn.com'
    },
    {
        guests: 0,
        name: '',
        emails: ''
    },
    {
        guests: 0,
        name: 'Delta Alpha',
        emails: ''
    },
    {
        guests: 1,
        name: 'Andrew Cureton',
        emails: 'drewcureton@gmail.com'
    },
    {
        guests: 2,
        name: 'Andrew & Jasmine Suggs',
        emails: 'andrew@livechair.co'
    },
    {
        guests: 1,
        name: 'Victor Blair',
        emails: 'Vblairii@gmail.com'
    },
    {
        guests: 1,
        name: 'Diqwuan Thompson',
        emails: 'Diqwuan@gmail.com'
    },
    {
        guests: 1,
        name: 'Terrence Orr',
        emails: 'terranceorr@gmail.com'
    },
    {
        guests: 1,
        name: 'Chibuzo Abara',
        emails: 'Iamabara@yahoo.com'
    },
    {
        guests: 1,
        name: 'Jordan Campbell ',
        emails: 'jordan@altspacechicago.com'
    },
    {
        guests: 1,
        name: 'James Stroman',
        emails: 'Jamstroman@gmail.com'
    },
    {
        guests: 1,
        name: 'Courtland Jones',
        emails: 'Cortlandt.jonesvii@gmail.com'
    },
    {
        guests: 1,
        name: 'Marcus Howard',
        emails: 'howar630@umn.edu'
    },
    {
        guests: 1,
        name: 'Claros Morean',
        emails: 'Clarosmorean@gmail.com'
    },
    {
        guests: 1,
        name: 'James Ukariuo',
        emails: 'Ukariwojames@gmail.com'
    },
    {
        guests: 1,
        name: 'Teon Moore',
        emails: 'Teonmoore@gmail.com'
    },
    {
        guests: 1,
        name: 'Efe Odige',
        emails: ''
    },
    {
        guests: 1,
        name: 'Michael ukariuwo',
        emails: 'miukariwo@gmail.com'
    },
    {
        guests: 1,
        name: 'Royce Reynolds',
        emails: 'royceareynolds@gmail.com'
    },
    {
        guests: 1,
        name: 'Colin Nelson',
        emails: 'Colinnelson06@gmail.com'
    },
    {
        guests: 2,
        name: 'Ryan & Courtney Moody',
        emails: 'themoodys18@gmail.com'
    },
    {
        guests: 1,
        name: 'Durontez Washington',
        emails: 'durontezw@gmail.com'
    },
    {
        guests: 1,
        name: 'Darius Stanton',
        emails: 'Dariusstanton7@gmail.com'
    },
    {
        guests: 1,
        name: 'Tousaint Brock',
        emails: 'toubrock0648@gmail.com'
    },
    {
        guests: 2,
        name: 'Corly (Matthew) & Dominique Moore',
        emails: 'cmoore102589@gmail.com'
    },
    {
        guests: 0,
        name: 'Joey Hilton +1',
        emails: 'Joeyrhilton@gmail.com'
    },
    {
        guests: 0,
        name: 'Justin Scott',
        emails: 'justinscott1288@gmail '
    },
    {
        guests: 0,
        name: '',
        emails: ''
    },
    {
        guests: 0,
        name: 'Gamma Nu',
        emails: ''
    },
    {
        guests: 1,
        name: 'Tiara Anderson',
        emails: 'tiaraandersonmsw@gmail.com'
    },
    {
        guests: 2,
        name: 'Detron & Kiara Williams',
        emails: 'kiararavenell@gmail.com'
    },
    {
        guests: 2,
        name: 'Bria Spivey & Jacob Lockley',
        emails: 'bria.spivey@gmail.com'
    },
    {
        guests: 1,
        name: 'Faith Green',
        emails: 'greenefaith71@gmail.com'
    },
    {
        guests: 1,
        name: 'Danielle Wilson',
        emails: 'daniellewilson49@gmail.com'
    },
    {
        guests: 1,
        name: 'Deja Shaw',
        emails: 'dejarshaw@gmail.com'
    },
    {
        guests: 1,
        name: 'Kinyetta Cambell',
        emails: 'Campbell.t.Kinyetta@gmail.com'
    },
    {
        guests: 1,
        name: 'Amani Turnage',
        emails: 'amaniturnage@gmail.com'
    },
    {
        guests: 1,
        name: 'Miriam Johnson',
        emails: 'Miriamjohnsonesq@outlook.com'
    },
    {
        guests: 1,
        name: 'Takiya Jackson',
        emails: 'takiyamgeorge@gmail.com'
    },
    {
        guests: 1,
        name: 'Sierra Youngblood',
        emails: 'syoungblood93@gmail.com'
    },
    {
        guests: 1,
        name: 'Angel Moorer',
        emails: 'angelmoorer1@gmail.com'
    },
    {
        guests: 1,
        name: 'Armani Harold',
        emails: 'armaniharrell@yahoo.com'
    },
    {
        guests: 1,
        name: 'Ahja Glaze',
        emails: 'glazeahja8@gmail.com '
    },
    {
        guests: 1,
        name: 'Michelle Simmons',
        emails: 'micsimmons93@gmail.com '
    },
    {
        guests: 2,
        name: 'Brandon & Tyler King',
        emails: 'tsbreland@yahoo.com'
    },
    {
        guests: 1,
        name: 'Nicole Ruff',
        emails: 'slim2fly@icloud.com'
    },
    {
        guests: 0,
        name: '',
        emails: ''
    },
    {
        guests: 0,
        name: 'Friends (Chelsi)',
        emails: ''
    },
    {
        guests: 1,
        name: 'Tashari Allen',
        emails: 'allenta603@gmail.com'
    },
    {
        guests: 2,
        name: 'John & Kayla Wilson',
        emails: 'jwilso17@gmail.com'
    },
    {
        guests: 2,
        name: 'Vince & Amber Licari',
        emails: 'vincejlicari@gmail.com, amberlicari@gmail.com'
    },
    {
        guests: 1,
        name: 'Chasity Grover',
        emails: 'chasity.grover5@gmail.com'
    },
    {
        guests: 2,
        name: 'Vince Vance & Victoria',
        emails: 'Vincentlvance@gmail.com'
    },
    {
        guests: 1,
        name: 'Naomi Thompson',
        emails: 'thompson5240@gmail.com'
    },
    {
        guests: 1,
        name: 'Flo Flowers',
        emails: 'flowers.bflo@gmail.com'
    },
    {
        guests: 2,
        name: 'Marcus & Tai Sedberry',
        emails: 'Taburleson@gmail.com'
    },
    {
        guests: 1,
        name: 'Shayla Yon',
        emails: 'shayla.yon23@gmail.com'
    },
    {
        guests: 1,
        name: 'Chelsea Addison',
        emails: 'chelseasarae@gmail.com'
    },
    {
        guests: 1,
        name: 'Britney Cheney',
        emails: 'britneycheney@gmail.com'
    },
    {
        guests: 1,
        name: 'Darrell Roberts',
        emails: 'Daroberts820@gmail.com'
    },
    {
        guests: 1,
        name: 'Marcela Lima',
        emails: 'Mblima32@gmail.com'
    },
    {
        guests: 1,
        name: 'LaCharles Beatty',
        emails: 'Beattyterrell233@gmail.com'
    },
    {
        guests: 2,
        name: 'Brian & Lauren Lackey',
        emails: 'lauren@laurenmwatts.com'
    },
    {
        guests: 2,
        name: 'Darrell & Jourdan Solee',
        emails: 'Jourdanlsolee@gmail.com'
    },
    {
        guests: 2,
        name: 'Darius Dixson & Neki Bosh',
        emails: 'darius@dariusscott.com'
    },
    {
        guests: 1,
        name: 'CaShana Hamler',
        emails: 'cashanah@gmail.com'
    },
    {
        guests: 0,
        name: '',
        emails: ''
    },
    {
        guests: 0,
        name: 'Other (Chelsi)',
        emails: ''
    },
    {
        guests: 2,
        name: 'Greg & Wendy Curtis',
        emails: 'wencurt63@gmail.com'
    },
    {
        guests: 2,
        name: 'Reuben Baker & Billi Jean Johnson',
        emails: 'reubenbaker1962@gmail.com'
    },
    {
        guests: 2,
        name: 'Alvin & Betty Freeman',
        emails: 'ajbjf@bellsouth.net'
    },
    {
        guests: 2,
        name: 'Moses & Shaw Afful',
        emails: 'reubenbaker1962@gmail.com'
    },
    {
        guests: 2,
        name: 'Darnell & Jennifer Pough',
        emails: 'jdpough64@gmail.com'
    },
    {
        guests: 1,
        name: 'Kellye Terrell',
        emails: 'terr2539@comcast.net'
    },
    {
        guests: 1,
        name: 'Tony Terrell (little)',
        emails: 'tj1terrell@gmail.com'
    },
    {
        guests: 1,
        name: 'Miko Jones',
        emails: 'Mikoajones@gmail.com'
    },
    {
        guests: 1,
        name: 'Aazia Aaron',
        emails: 'aazia_aazia@yahoo.com'
    },
    {
        guests: 2,
        name: 'Corey & Raquel Jackson',
        emails: 'jcorey6@yahoo.com'
    },
    {
        guests: 1,
        name: 'Virgie Greene',
        emails: 'vlag@bellsouth.net'
    },
    {
        guests: 1,
        name: 'Vickie Clark',
        emails: 'clarkvickiesherell@gmail.com'
    },
    {
        guests: 2,
        name: 'Glyn Stanley & Valyricka Dixon ',
        emails: 'glyn@gasp-pix.com'
    },
    {
        guests: 2,
        name: 'Ron & Denise Yarbrough',
        emails: 'Ronitpro@gmail.com'
    },
    {
        guests: 1,
        name: 'Kimberly Thompson ',
        emails: 'Kimt914@yahoo.com'
    },
    {
        guests: 0,
        name: '',
        emails: ''
    },
    {
        guests: 0,
        name: 'Friends (Spence)',
        emails: ''
    },
    {
        guests: 1,
        name: 'Mitch Benjamin',
        emails: 'mbenjam5@yahoo.com'
    },
    {
        guests: 2,
        name: 'Ryan & Porshia King',
        emails: 'ryanthonyking@gmail.com'
    },
    {
        guests: 1,
        name: 'Law Wilson',
        emails: 'Law.wilson.a@gmail.com'
    },
    {
        guests: 2,
        name: 'Bre & John',
        emails: 'Brianna.endrina@gmail.com'
    },
    {
        guests: 2,
        name: 'Theo Anderson & Cara Davis',
        emails: 'caraleighdavis@gmail.com'
    },
    {
        guests: 1,
        name: 'Chauncey Woods',
        emails: ''
    },
    {
        guests: 2,
        name: 'Terrence Fuller & Meika',
        emails: 'solidartsllc@gmail.com'
    },
    {
        guests: 1,
        name: 'Blake Gilley',
        emails: 'wbgilley@yahoo.com'
    },
    {
        guests: 1,
        name: 'Lance Brown',
        emails: 'Clansingbrown13@gmail.com'
    },
    {
        guests: 1,
        name: 'Tim Webb +1',
        emails: 'Timothylwebbjr@gmail.com'
    },
    {
        guests: 1,
        name: 'Isaiah Nelson',
        emails: 'Isaiahnelson14@gmail.com'
    },
    {
        guests: 2,
        name: 'Keiwon Brown +1',
        emails: 'Keiwonb@yahoo.com'
    },
    {
        guests: 2,
        name: 'Jeremy Goodwin +1',
        emails: 'jeremygoodwin23@yahoo.com'
    },
    {
        guests: 2,
        name: 'Abdul Roberts+1',
        emails: 'robertsabdul13@gmail.com'
    },
    {
        guests: 1,
        name: 'Dexter Thorton',
        emails: 'thornton.dexter@gmail.com'
    },
    {
        guests: 1,
        name: 'Dominique Hammond',
        emails: 'Dominique.hammond10@icloud.com'
    },
    {
        guests: 2,
        name: 'Jamal Commander +1',
        emails: 'Jamal.commander@gmail.com'
    },
    {
        guests: 2,
        name: 'Rashaunn Ruffin+1',
        emails: 'rruffin383@gmail.com'
    },
    {
        guests: 1,
        name: 'Jamon Boulware',
        emails: 'jamoneb@gmail.com'
    },
    {
        guests: 0,
        name: '',
        emails: ''
    },
    {
        guests: 0,
        name: 'Other(Spence)',
        emails: ''
    },
    {
        guests: 2,
        name: 'Michael & Angela Mcdaniel',
        emails: '37michaelmcdaniel@gmail.com'
    },
    {
        guests: 2,
        name: 'Andereas & Sandra Corley',
        emails: 'Dreaus@gmail.com'
    },
    {
        guests: 2,
        name: 'Smokey& Gertrude Cunningham',
        emails: ''
    }
];

export const validReservationEmails = [
    {
        name: 'Cori & Rocko Bolts',
        emails: ['clpinkett@gmail.com', 'rocmystyle_cc@icloud.com', 'rocmystyle_cc@yahoo.com'],
        guests: 2
    },
    {
        name: 'River Washington',
        emails: 'riverwashington@gmail.com',
        guests: 1
    },
    {
        name: 'Tiara Wright',
        emails: 'tiarawright16@gmail.com',
        guests: 1
    },
    {
        name: 'Keiko Cooley',
        emails: 'keikocooley@gmail.com',
        guests: 1
    },
    {
        name: 'Tiara Myrick',
        emails: 'tmyrick16@gmail.com',
        guests: 1
    },
    {
        name: 'Jalisa Washington',
        emails: 'jalwashington2@gmail.com',
        guests: 1
    },
    {
        name: 'Shardae Moore & Milton Davis',
        emails: 'shardaemoore22@yahoo.com',
        guests: 2
    },
    {
        name: 'Avery & Baylee Johnson',
        emails: 'baylee_hawkins@yahoo.com',
        guests: 2
    },
    {
        name: 'Jordan Pinkett & Emi Douglas',
        emails: 'jpinkett619@gmail.com',
        guests: 2
    },
    {
        name: 'James & Tori Cunningham',
        emails: 'jamcunningham2@gmail.com',
        guests: 2
    },
    {
        name: 'Zae & Liana Holland',
        emails: 'zaphane.holland@gmail.com',
        guests: 2
    },
    {
        name: 'Arthur Brown',
        emails: 'abrownchas1@gmail.com',
        guests: 1
    },
    {
        name: 'Trey Swinton',
        emails: 'treyswinton@gmail.com',
        guests: 1
    },
    {
        name: 'John & Caitlin Swinton',
        emails: 'johncfswinton@gmail.com',
        guests: 2
    },
    {
        name: 'Monte & Sharon Pinkett',
        emails: 'SRCPinkett@gmail.com',
        guests: 2
    },
    {
        name: 'Dee Cannedy & Robert Lowery',
        emails: 'cannedy42@gmail.com',
        guests: 2
    },
    {
        name: 'Pamela Pinkett',
        emails: 'pspinkett@aol.com',
        guests: 1
    },
    {
        name: 'Philip & Louise Johnson',
        emails: 'lkjohnson25@yahoo.com',
        guests: 2
    },
    {
        name: 'Granny (Spence)',
        emails: null,
        guests: 1
    },
    {
        name: 'Tamara Pinkett & Will Beasley',
        emails: 'tpstat89@gmail.com',
        guests: 2
    },
    {
        name: 'Shawn & Ann Pinkett',
        emails: 'cadada@bellsouth.net',
        guests: 2
    },
    {
        name: 'John Cannedy',
        emails: 'Jecannedy3@gmail.com',
        guests: 1
    },
    {
        name: 'Benjamin Cannedy',
        emails: 'bkingtodd2@gmail.com',
        guests: 1
    },
    {
        name: 'Lavesta Johnson',
        emails: null,
        guests: 1
    },
    {
        name: 'Domino & Jackie Boulware',
        emails: 'boulwa_j@bellsouth.net',
        guests: 2
    },
    {
        name: 'Deloris Johnson',
        emails: 'deloreshurt@yahoo.com',
        guests: 1
    },
    {
        name: 'Vera Burkett',
        emails: 'Veramburkett1948@gmail.com',
        guests: 1
    },
    {
        name: 'Aunt Jackie Stimage-Norwood',
        emails: 'Jsn4032@gmail.com',
        guests: 1
    },
    {
        name: 'Mary Ayers',
        emails: 'maryayers@bellsouth.net',
        guests: 1
    },
    {
        name: 'Michael & Lynda Whiteside',
        emails: 'mslynda50@hotmail.com',
        guests: 2
    },
    {
        name: 'William & Cheryl Swinton',
        emails: ['cherylswinton27@gmail.com', 'williamswinton@aol.com'],
        guests: 2
    },
    {
        name: 'Caroline Swinton',
        emails: 'carolynswinton@hotmail.com',
        guests: 1
    },
    {
        name: 'Collin & Adrian Hayes',
        emails: null,
        guests: 2
    },
    {
        name: 'Harold & Diane Swinton',
        emails: 'haroldlswinton@gmail.com',
        guests: 2
    },
    {
        name: 'Angela Bishop',
        emails: 'Adbishop67@gmail.com',
        guests: 1
    },
    {
        name: 'Ruby Bishop',
        emails: 'rbee1952@yahoo.com',
        guests: 1
    },
    {
        name: 'Howard & Joy Hamilton',
        emails: 'HowardHamiltonJR@gmail.com',
        guests: 2
    },
    {
        name: 'Shayla Aytch (Marcie) & Husband',
        emails: 'angels2love7@yahoo.com',
        guests: 2
    },
    {
        name: 'Rayonna Dixon',
        emails: 'rayonnadixon04@gmail.com',
        guests: 1
    },
    {
        name: 'Mark Aytch & Betty McAllister',
        emails: 'markasr1971@gmail.com',
        guests: 2
    },
    {
        name: 'Melodie Gale',
        emails: 'mgale0303@gmail.com',
        guests: 1
    },
    {
        name: 'Carolyn Opher',
        emails: 'copher1@verizon.net',
        guests: 1
    },
    {
        name: 'Aunt JoAnne Kirkwood',
        emails: null,
        guests: 1
    },
    {
        name: 'Aunt Donzell Aytch',
        emails: null,
        guests: 1
    },
    {
        name: 'Aunt Bobbie (Adam & Barbara Haynes)',
        emails: ['01reginagale@comcast.net', 'reginagale@comcast.net'],
        guests: 2
    },
    {
        name: 'Quincy & Billie Verne Harrison',
        emails: 'blvharrison@aol.com',
        guests: 2
    },
    {
        name: 'Romandie Green',
        emails: 'romandiegreen@comcast.net',
        guests: 1
    },
    {
        name: 'Meredith Green',
        emails: 'meg70128@hotmail.com',
        guests: 1
    },
    {
        name: 'Teddy & Doris Jeter',
        emails: ['dorisjeter4548@comcast.net', 'Theodorejeter88@gmail.com'],
        guests: 2
    },
    {
        name: 'Tia Selby',
        emails: 'Tiaselby@hotmail.com',
        guests: 1
    },
    {
        name: 'Uncle Chuck',
        emails: null,
        guests: 1
    },
    {
        name: 'Hewitt Doane',
        emails: 'Htdoane@yahoo.com',
        guests: 1
    },
    {
        name: 'Traci McKinney',
        emails: 'MSTRM3@yahoo.com',
        guests: 1
    },
    {
        name: 'DeJean Cannedy',
        emails: 'therealdejean@gmail.com',
        guests: 1
    },
    {
        name: 'LaQuiesha Cannedy',
        emails: null,
        guests: 1
    },
    {
        name: 'Benjamin Todd Cannedy',
        emails: 'Bkingtodd2@gmail.com',
        guests: 1
    },
    {
        name: 'Demetrius & Melanie McKinney',
        emails: 'Dmckinney2409@gmail.com',
        guests: 2
    },
    {
        name: 'Dante McKinney',
        emails: 'yungmcpc1212@gmail.com',
        guests: 1
    },
    {
        name: 'Richard & Janice Calloway',
        emails: 'janicesc39@yahoo.com',
        guests: 2
    },
    {
        name: 'Kevin & Kelley Young',
        emails: 'drkelleyyoung@gmail.com',
        guests: 2
    },
    {
        name: 'Elan Texiera',
        emails: 'ejaedinc@gmail.com',
        guests: 1
    },
    {
        name: 'Anissa Collins',
        emails: 'flossnbrush2@yahoo.com',
        guests: 1
    },
    {
        name: 'Jameliah Byrd-Daniels',
        emails: 'J.shanai91@gmail.com',
        guests: 1
    },
    {
        name: 'Joron (Jojo) Stimage-Norwood',
        emails: 'jnorwood20@pm.me',
        guests: 1
    },
    {
        name: 'Marcus Stimage-Norwood',
        emails: null,
        guests: 1
    },
    {
        name: 'Vashti Hurt',
        emails: 'vashti.hurt@yahoo.com',
        guests: 1
    },
    {
        name: 'Yolanda & George Brown',
        emails: ['Yolandamburkett@icloud.com', 'Gpscolumbiasc@gmail.com'],
        guests: 2
    },
    {
        name: 'Nina-Serena & Mason Olonade',
        emails: 'Sirinafae05@yahoo.com',
        guests: 2
    },
    {
        name: 'Nia Stimage Norwood',
        emails: 'niastimnor@gmail.com',
        guests: 1
    },
    {
        name: 'Aaron Stimage-Norwood',
        emails: null,
        guests: 1
    },
    {
        name: 'Erica Ladson',
        emails: 'erica_ladson@yahoo.com',
        guests: 1
    },
    {
        name: 'Ashley Ladson',
        emails: 'Ashley_Ladson@yahoo.com',
        guests: 1
    },
    {
        name: 'Fred & Angie Ladson',
        emails: 'Angelaladson@aol.com',
        guests: 2
    },
    {
        name: 'Cousin Frankie & Lisa Summers',
        emails: null,
        guests: 2
    },
    {
        name: 'Nathalie Owens & Annette Morrison',
        emails: null,
        guests: 2
    },
    {
        name: 'Aunt Cathy Summers',
        emails: null,
        guests: 1
    },
    {
        name: 'Lorren Summers',
        emails: null,
        guests: 1
    },
    {
        name: 'Brittany Summers',
        emails: null,
        guests: 1
    },
    {
        name: 'Athena Davis',
        emails: 'pandora197473@yahoo.com',
        guests: 1
    },
    {
        name: 'Cousin Harold Swinton',
        emails: null,
        guests: 1
    },
    {
        name: 'Cousin Avery Swinton',
        emails: null,
        guests: 1
    },
    {
        name: 'TamRhan Mack',
        emails: 'tamrhanyvette@gmail.com',
        guests: 1
    },
    {
        name: 'Tamia Whiteside',
        emails: 'kool28kidz@gmail.com',
        guests: 1
    },
    {
        name: 'Faith White',
        emails: null,
        guests: 1
    },
    {
        name: 'Keosha Ayers',
        emails: 'silvergal2003@yahoo.com',
        guests: 1
    },
    {
        name: 'Kyrah Ayers',
        emails: null,
        guests: 1
    },
    {
        name: 'Keaunna Preheim',
        emails: 'preheimmom@gmail.com',
        guests: 1
    },
    {
        name: 'Aliah Ayers',
        emails: null,
        guests: 1
    },
    {
        name: 'Heather Swinton',
        emails: 'hlswinton@msn.com',
        guests: 1
    },
    {
        name: 'Andrew Cureton',
        emails: 'drewcureton@gmail.com',
        guests: 1
    },
    {
        name: 'Andrew & Jasmine Suggs',
        emails: 'andrew@livechair.co',
        guests: 2
    },
    {
        name: 'Victor Blair',
        emails: 'Vblairii@gmail.com',
        guests: 1
    },
    {
        name: 'Diqwuan Thompson',
        emails: 'Diqwuan@gmail.com',
        guests: 1
    },
    {
        name: 'Terrence Orr',
        emails: 'terranceorr@gmail.com',
        guests: 1
    },
    {
        name: 'Chibuzo Abara',
        emails: 'Iamabara@yahoo.com',
        guests: 1
    },
    {
        name: 'Jordan Campbell',
        emails: 'jordan@altspacechicago.com',
        guests: 1
    },
    {
        name: 'James Stroman',
        emails: 'Jamstroman@gmail.com',
        guests: 1
    },
    {
        name: 'Courtland Jones',
        emails: 'Cortlandt.jonesvii@gmail.com',
        guests: 1
    },
    {
        name: 'Marcus Howard',
        emails: 'howar630@umn.edu',
        guests: 1
    },
    {
        name: 'Claros Morean',
        emails: 'Clarosmorean@gmail.com',
        guests: 1
    },
    {
        name: 'James Ukariuo',
        emails: 'Ukariwojames@gmail.com',
        guests: 1
    },
    {
        name: 'Teon Moore',
        emails: 'Teonmoore@gmail.com',
        guests: 1
    },
    {
        name: 'Efe Odige',
        emails: null,
        guests: 1
    },
    {
        name: 'Kimberly Thompson',
        emails: 'kimt914@yahoo.com',
        guests: 1
    },
    {
        name: 'Rev. Clark',
        emails: 'clarkvickiesherell@gmail.com',
        guest: 1
    },
    {
        name: 'Miko Jones',
        emails: 'mikoajones@gmail.com',
        guest: 1
    },
    {
        name: 'Brian & Lauren Lackey',
        emails: 'lauren@laurenmwatts.com',
        guest: 2
    },
    {
        name: 'Robert Sabdul',
        emails: 'robertsabdul13@gmail.com',
        guest: 2
    },
    {
        name: 'Chauncey Woods',
        emails: 'Cwoods559@gmail.com',
        guest: 1
    },
    {
        name: 'Kellye Terrell',
        emails: 'Kdht322@gmail.com',
        guest: 1
    },
    {
        name: 'Michael & Lynda Whiteside',
        emails: 'deltawoman5@gmail.com',
        guest: 2
    },
    {
        name: 'Andrea Corley',
        emails: 'robertsabdul13@gmail.com',
        guest: 2
    },

    {
        name: 'nina.serenaburkett@gmail.com',
        emails: 'nina.serenaburkett@gmail.com',
        guests: 2
    },
    {
        name: 'Veramburkett1949@gmail.com',
        emails: 'Veramburkett1949@gmail.com',
        guests: 1
    },
    {
        name: 'Bigdog29118@yahoo.com',
        emails: 'Bigdog29118@yahoo.com',
        guests: 2
    },
    {
        name: 'Johnsonzachariah@yahoo.com',
        emails: 'Johnsonzachariah@yahoo.com',
        guests: 2
    },
    {
        name: 'summerssstrs@aol.com',
        emails: 'summerssstrs@aol.com',
        guests: 1
    },
    {
        name: 'lolady04@gmail.com',
        emails: 'lolady04@gmail.com',
        guests: 1
    },
    {
        name: 'summersbm@yahoo.com',
        emails: 'summersbm@yahoo.com',
        guests: 1
    },
    {
        name: 'Erwin Johnson',
        emails: 'phillip@phillipljohnson.com',
        guests: 1
    },
    {
        name: 'Antwan Jones',
        emails: 'Twan11j1@yahoo.com',
        guests: 1
    },
    {
        name: 'Vera Mae',
        emails: 'Veramburkett1949@gmail.com',
        guests: 1
    },
    {
        name: 'Latise Irving',
        emails: 'Latiseirving@gmail.com',
        guests: 1
    },
    //Test Users
    {
        name: 'Testing',
        emails: ['jjames@nutastic.net', 'service@nutastic.net', 'chelsi.pinkett@gmail.com', 'hello@russellwendell.com'],
        guests: 2
    },

    ...googleSheetListExport
];
